import { render } from "./DjRebateTab.vue?vue&type=template&id=4db49385&scoped=true"
import script from "./DjRebateTab.vue?vue&type=script&lang=js"
export * from "./DjRebateTab.vue?vue&type=script&lang=js"

import "./DjRebateTab.vue?vue&type=style&index=0&id=4db49385&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-4db49385"

export default script